import * as Icon from "@ant-design/icons";
import { Button, Col, DatePicker, DatePickerProps, Flex, Form, Image, Modal, Row, Select, Tooltip } from "antd";
import { ColumnsType } from "antd/lib/table/interface";
import dayjs from "dayjs";
import { useEffect } from "react";
import { ButtonComponent } from "../../../../components/button/cadastrar";
import MensagemModal from "../../../../components/modal/mensagem";
import AcoesComponent from "../../../../components/table/acoesComponent";
import TableComponent from "../../../../components/table/tableComponent";
import { EmpresaModel } from "../../../../models/empresa/empresaModel";
import { ItemMenuAcoes } from "../../../../models/sistema/itemMenuAcoes";
import { BuscarSorteioModel } from "../../../../models/sorteio/buscarSorteioModel";
import { SorteioDTOModel } from "../../../../models/sorteio/sorteioDTOModel";
import { setIdEmpresaPermissao, setTitle } from "../../../../redux/slices/configuracoes/configuracoesSlice";
import { fillEntityCG, fillEntityGradePremiacao, setBuscaSorteio, setEntitySorteio, setModalDeletarSorteio, setPageSorteio } from "../../../../redux/slices/sorteio/sorteioSlice";
import { buscarCondicaoGeralSorteio } from "../../../../services/condicaoGeralSorteioService";
import { buscarEmpresa } from "../../../../services/empresaService";
import { buscarGradePremiacao } from "../../../../services/gradePremiacaoService";
import { buscarSorteio, deletarSorteio } from "../../../../services/sorteioService";
import { buscarTipoSorteio } from "../../../../services/tipoSorteioService";
import { formatData } from "../../../../util/dataAuxiliar";
import { currencyBRL } from "../../../../util/dinheiroBRAuxiliar";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import "./style/index.scss";

dayjs.locale("pt-br");

const GeralPage = () => {
  //estados globais
  const sorteioState = useAppSelector((state) => state.sorteio);
  const empresaState = useAppSelector((state) => state.empresa);
  const condicaoGeralSorteioState = useAppSelector((state) => state.condicaoGeralSorteio);
  const gradePremiacaoState = useAppSelector((state) => state.gradePremiacao);
  const tipoSorteioState = useAppSelector((state) => state.tipoSorteio);
  const persistedState = useAppSelector((state) => state.persisted);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(setTitle("SORTEIOS"));
    dispatch(buscarEmpresa(empresaState.busca));
    dispatch(buscarTipoSorteio(tipoSorteioState.busca));
    dispatch(buscarGradePremiacao(gradePremiacaoState.busca));
    dispatch(buscarCondicaoGeralSorteio(condicaoGeralSorteioState.busca));
    dispatch(buscarSorteio(sorteioState.busca));
    if (persistedState.user.empresa !== null) {
      onChangeEmpresa(persistedState.user.empresa.idEmpresa);
      form.setFieldsValue({
        idEmpresa: persistedState.user.empresa.idEmpresa,
        dataInicial: dayjs(sorteioState.busca.dataInicial),
        dataFinal: dayjs(sorteioState.busca.dataFinal),
        tipoSorteio: sorteioState.busca.idTipoSorteio,
      });
    } else {
      sorteioState.busca.idEmpresas && onChangeEmpresa(parseInt(sorteioState.busca.idEmpresas));

      form.setFieldsValue({
        idEmpresa: sorteioState.busca.idEmpresas && parseInt(sorteioState.busca.idEmpresas),
        dataInicial: dayjs(sorteioState.busca.dataInicial),
        dataFinal: dayjs(sorteioState.busca.dataFinal),
        tipoSorteio: sorteioState.busca.idTipoSorteio,
      });
    }
  }, []);

  const goCadastrar = () => {
    dispatch(setEntitySorteio({}));
    dispatch(setPageSorteio("cadastrar"));
  };

  const goEditar = (value: SorteioDTOModel) => {
    dispatch(setEntitySorteio(value));
    var CG = condicaoGeralSorteioState.list.find((a: any) => a.id === value.idCondicaoGeralSorteio);
    var Grade = gradePremiacaoState.list.find((a: any) => a.id === value.idGradePremiacao);
    if (CG !== undefined && Grade !== undefined) {
      dispatch(fillEntityCG(CG));
      dispatch(fillEntityGradePremiacao(Grade));
      dispatch(setPageSorteio("cadastrar"));
    }
  };

  const goDeletar = (value: SorteioDTOModel) => {
    dispatch(setEntitySorteio(value));
    dispatch(setModalDeletarSorteio(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarSorteio(false));
  };

  const goResumo = (value: SorteioDTOModel) => {
    dispatch(setEntitySorteio(value));
    dispatch(setPageSorteio("resumo"));
  };

  const onChangeDateInicio = (value: DatePickerProps["value"], dateString: string | string[]) => {
    let busca: BuscarSorteioModel = { ...sorteioState.busca, dataInicial: value !== null ? dayjs(value).format("DD/MM/YYYY") : null };

    dispatch(setBuscaSorteio(busca));
    dispatch(buscarSorteio(busca));
  };

  const onChangeDateFim = (value: DatePickerProps["value"], dateString: string | string[]) => {
    let busca = { ...sorteioState.busca, dataFinal: value !== null ? dayjs(value).format("DD/MM/YYYY") : null };

    dispatch(setBuscaSorteio(busca));
    dispatch(buscarSorteio(busca));
  };

  const onChangeEmpresa = (value: number) => {
    dispatch(setIdEmpresaPermissao(value));

    let busca: BuscarSorteioModel = { ...sorteioState.busca, idEmpresas: value === undefined ? null : value.toString() };

    dispatch(setBuscaSorteio(busca));
    dispatch(buscarSorteio(busca));
  };

  const onChangeTipoSorteio = (value: number) => {
    let busca: BuscarSorteioModel = { ...sorteioState.busca, idTipoSorteio: value };

    dispatch(setBuscaSorteio(busca));
    dispatch(buscarSorteio(busca));
  };

  const atualizar = () => {
    dispatch(buscarSorteio(sorteioState.busca));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const columns: ColumnsType<any> = [
    {
      title: "EMPRESA",
      dataIndex: "empresa",
    },
    {
      title: "PRÊMIO BRUTO",
      dataIndex: "valorTotalPremiacaoBruto",
      align: "right",
      render: (_, record) => (record.valorTotalPremiacaoBruto === undefined ? "" : currencyBRL(record.valorTotalPremiacaoBruto)),
    },
    {
      title: "PRÊMIO LÍQUIDO",
      dataIndex: "valorTotalPremiacaoLiquido",
      align: "right",
      render: (_, record) => (record.valorTotalPremiacaoLiquido === undefined ? "" : currencyBRL(record.valorTotalPremiacaoLiquido)),
    },
    {
      title: "VALOR DO TÍTULO",
      dataIndex: "valorTitulo",
      align: "right",
      render: (_, record) => (record.valorTitulo === undefined ? "" : currencyBRL(record.valorTitulo)),
    },
    {
      title: "C.G",
      dataIndex: "numeroProcesso",
      align: "right",
      render: (_, record) => (record.numeroProcesso === undefined ? "" : currencyBRL(record.numeroProcesso)),
    },
    {
      title: "TIPO SORTEIO",
      dataIndex: "tipoSorteio",
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      render: (_, record) => !record.sorteio && <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical" form={form} onFinish={goCadastrar}>
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              {persistedState.user.empresa === null && (
                <Form.Item label="Empresa" name="idEmpresa">
                  <Select
                    allowClear
                    showSearch
                    optionFilterProp="labelSearch"
                    loading={empresaState.loading}
                    onChange={onChangeEmpresa}
                    style={{ width: 300 }}
                    options={empresaState.list.map((a: EmpresaModel) => ({
                      value: a.id,
                      key: a.apelido,
                      label: (
                        <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                          <Flex style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</Flex>
                          {a.apelido}
                        </Flex>
                      ),
                      labelSearch: a.apelido,
                    }))}
                  />
                </Form.Item>
              )}
              <Form.Item label="Tipo de sorteio" name="tipoSorteio">
                <Select
                  allowClear
                  onChange={onChangeTipoSorteio}
                  style={{ width: 180 }}
                  loading={tipoSorteioState.loading}
                  options={tipoSorteioState.list.map((a: any) => ({
                    value: a.id,
                    label: a.denominacao,
                    disabled: !a.ativo,
                  }))}
                />
              </Form.Item>
              <Form.Item label="Data início" name="dataInicio">
                <DatePicker placeholder="" onChange={onChangeDateInicio} format="DD/MM/YYYY" style={{ width: 120 }} />
              </Form.Item>
              <Form.Item label="Data fim" name="dataFim">
                <DatePicker placeholder="" onChange={onChangeDateFim} format="DD/MM/YYYY" style={{ width: 120 }} />
              </Form.Item>
              <Form.Item label=" ">
                <Tooltip title="Atualizar">
                  <Button icon={<Icon.RedoOutlined />} className="buttonPrimary" style={{ minHeight: 32 }} onClick={atualizar} />
                </Tooltip>
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="flex-end">
              <ButtonComponent htmlType="submit" />
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent
        data={sorteioState.list}
        loading={sorteioState.loading}
        columns={columns}
        expandable={{
          childrenColumnName: "sorteio",
          expandRowByClick: true,
          expandIcon: ({ expanded, onExpand, record }: any) => {
            if (!record.sorteio || record.sorteio.length === 0) return null;
            return expanded ? (
              <Flex justify="flex_start" align="center" gap={7} className="spanHeaderRow" onClick={(e) => onExpand(!record, e)}>
                <Icon.MinusCircleTwoTone />
                <span>{formatData(record.sorteio[0].dataSorteio.substring(0, 10))}</span>
              </Flex>
            ) : (
              <Flex justify="flex_start" align="center" gap={7} className="spanHeaderRow" onClick={(e) => onExpand(record, e)}>
                <Icon.PlusCircleTwoTone />
                <span>{formatData(record.sorteio[0].dataSorteio.substring(0, 10))}</span>
              </Flex>
            );
          },
        }}
        tableProps={{
          className: "tableSorteio",
          onRow: (record: any) => ({
            onClick: () => {
              if (!record.sorteio) {
                goResumo(record);
              }
            },
          }),
        }}
      />
      <Modal title={"REMOVER SORTEIO"} centered width={350} open={sorteioState.modalDeletar} closable={false} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal text="Deseja remover o sorteio?" action={deletarSorteio({ value: sorteioState.entity.id, busca: sorteioState.busca })} close={setModalDeletarSorteio(false)} />
      </Modal>
    </Flex>
  );
};

export default GeralPage;
